import { DATA_SOURCES } from '@/config/constants';
import RelatedCategoriesSectionShell from './RelatedCategoriesSectionShell';

/**
 * Renders the consolidated Related Categories table for a TikTok category or
 * brand surface.
 *
 * Pass `isGroupVariant` when rendering the group rollup variant of the table.
 */
function RelatedCategoriesSectionTable(props) {
    return (
        <RelatedCategoriesSectionShell
            {...props}
            source={DATA_SOURCES.TIKTOK}
        />
    );
}

export default RelatedCategoriesSectionTable;
